import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { authActions } from "../../../redux/actions";
import Button from "../../../component/button/Button";
import ErrorRender from "../../../component/request/ErrorRender";
import HeaderTag from "../../../component/smallComponents/HeaderTag";
import P from "../../../component/smallComponents/P";
import SpinnerButton from "../../../component/spinner/SpinnerButton";
import TextInput from "../../../component/input/TextInput";

const Otp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [errors, setErrors] = useState("");
  // const [timeLeft, setTimeLeft] = useState(300);
  // const [timerOn, setTimerOn] = useState(true);
  const [receivedOtp, setReceivedOtp] = useState("");

  const {
    authError,
    authLoading,
    isAuthenticated,
    authResponse,
    currentUser
  } = useSelector((state) => state.auth);

  useEffect(() => {
    setErrors(authError);
  }, [authError]);

  // const timer = (remaining) => {
  //   let m = Math.floor(remaining / 60);
  //   let s = remaining % 60;

  //   m = m < 10 ? "0" + m : m;
  //   s = s < 10 ? "0" + s : s;
  //   const currentTime = m + ":" + s;
  //   setTimeLeft(currentTime);
  //   remaining -= 1;
  //   console.log(remaining);
  //   if (remaining >= 0) {
  //     setTimeout(function () {
  //       timer(remaining);
  //     }, 1000);
  //   } else {
  //     setTimerOn(false);
  //   }
  // };

  useEffect(() => {
    // timer(timeLeft);
    dispatch(authActions.clearAuthErrors());
    dispatch(authActions.clearAuthResult());
    dispatch(authActions.setAuthLoading(false));
    return () => {
      dispatch(authActions.clearAuthErrors());
      dispatch(authActions.clearAuthResult());
      // timer(0);
      // setTimerOn(false);
    };
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      navigate(
        `/dashboard/${currentUser.workerFirstName}/${currentUser.workerDepartment}`
      );
    }
  });

  const onSubmit = (e) => {
    e.preventDefault();
    const userInfo = {
      workerEmail: localStorage.workerEmail,
      workerPassword: "",
      otpAuthentication: true,
      otp: receivedOtp
    };
    const loginType = localStorage.loginType;
    dispatch(authActions.setAuthLoading(true));
    dispatch(authActions.clearAuthErrors());
    dispatch(authActions.clearAuthResult());
    dispatch(authActions.loginUser(userInfo, history, loginType));
  };

  // const onResend = () => {
  //   console.log("resend");
  //   setTimerOn(true);
  //   timer(120);
  // };

  return (
    <div className="authentication-bg">
      <div className="account-pages mt-5 mb-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-5">
              <div className="card">
                <div className="card-header pt-4 text-center bg-dark">
                  <span>
                    <img
                      src="https://i.imgur.com/ahvlkuu.png"
                      alt=""
                      height="35"
                    />
                  </span>
                </div>
                <div className="card-body p-4 bg-dark">
                  <div className="text-center w-75 m-auto">
                    <HeaderTag
                      title="Enter OTP to get verify by our system."
                      type="h4"
                      className="text-dark-50 text-center mt-0 font-weight-bold"
                      isClassName={true}
                    />

                    <P title={authResponse} />
                  </div>

                  <form onSubmit={onSubmit}>
                    <TextInput
                      type={"text"}
                      required={true}
                      textWhite={true}
                      value={receivedOtp}
                      label={"Enter OTP"}
                      htmlFor={"receivedOtp"}
                      placeholder={"Enter your OTP"}
                      onChange={(e) => setReceivedOtp(e.target.value)}
                    />
                    {/* <div className="form-group mb-0">
                      {timerOn ? (
                        <label className="ml-2 text-white">
                          Time Left - {timeLeft}
                        </label>
                      ) : (
                        <u
                          className="ml-2 text-white"
                          onClick={() => onResend()}
                        >
                          Resend Otp
                        </u>
                      )}
                    </div> */}

                    <div className="form-group mb-0 text-center mt-2">
                      {authLoading ? (
                        <SpinnerButton />
                      ) : (
                        <Button
                          title={"Submit Otp"}
                          icon="mdi mdi-login"
                          type="submit"
                          isBackgroundColor={true}
                        />
                      )}
                    </div>
                    {errors !== "" ? (
                      <ErrorRender errors={errors} />
                    ) : null}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer className="footer footer-alt">
        <p>
          Developed and maintain by{" "}
          <strong className="text-dark">VITORSCAPE</strong>
        </p>
        <p>
          Copyright ©{" "}
          <strong className="text-dark">VITORSCAPE</strong>
        </p>
      </footer>
    </div>
  );
};

export default Otp;
